<div [ngClass]="'cc-single-rich-field'">
  <span class="d-flex mt-n30 pb-2 pt-5">
    <span class="flex-1"></span>
<!--          <button pButton pRipple icon="pi pi-trash" class="p-button-text p-button-sm p-button-danger"-->
<!--                  (click)="clear()" [disabled]="disabled || !formRecord || !formRecord.title"></button>-->
  </span>
  <p-table #table
           [value]="[formRecord]" [loading]="tableLoading"
           [dataKey]="formRichFieldConfig.fieldId"
           selectionMode="multiple"
           [scrollable]="true"
           [resizableColumns]="true" [metaKeySelection]="true">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let columnDef of formRichFieldConfig.tableConfigs"
            [style.width]="columnDef.width ? columnDef.width+'px' : null">
          <div *ngIf="columnDef.field" class="flex justify-content-between align-items-center">
            {{columnDef.label ? columnDef.label : 'page.' + this.transPartKey + '.form.' + columnDef.field | translate}}
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
      <tr>
        <td *ngFor="let columnDef of formRichFieldConfig.tableConfigs; let i = index" [width]="columnDef.width"
            (click)="edit(record)"
            (dblclick)="edit(record)" (auxclick)="onRowRightClick_(record)">
          <span
            *ngIf="columnDef.field && !columnDef.command && !columnDef.format && !columnDef.mapId">
            {{record[columnDef.field]}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='DATETIME'||columnDef.type==='DATE')">
<!--            {{record[columnDef.field]  | date:columnDef.format}}-->
            {{record[columnDef.field] }}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='NUMERIC')">
            {{record[columnDef.field] | number:columnDef.format ? columnDef.format : '1.0-7'}}
          </span>
          <span *ngIf="columnDef.field && columnDef.mapId"
                [innerHTML]="fieldValueMap['mapId-' + i]">
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<app-cc-form-dialog #ccFormDialog [transPartKey]="transPartKey"
                   [loading]="false" [submitted]="submitted"
                   [(dialogFormVisible)]="dialogFormVisible"
                   [formConfig]="formRichFieldConfig.fields" [dialogFormTitle]="dialogFormTitle"
                   [(formRecord)]="formRecordInForm"
                   (onSubmitEvent)="save()"
                   [disableSubmitButton]="fieldValueMap['validate']"
                   [globalErrorMessage]="fieldValueMap['validate']"
></app-cc-form-dialog>
